module.exports = __webpack_public_path__ + "img/Sterling Bank.1b361885.png";